import React from 'react';

export const SignInTwoFactorUnsupported = () => {
    return (
        <>
            <h2 className='header__h2'>SignInTwoFactorUnsupported</h2>
        </>
    );
};
